/* eslint-disable react/prop-types */
// eslint-disable-next-line no-restricted-imports
import { t, Trans } from '@lingui/macro'
import BigNumber from 'bignumber.js'
import { ButtonGray, ButtonPrimary } from 'components/Button'
import { Input as NumericalInput } from 'components/NumericalInput'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useBankContract } from 'hooks/useContract'
import { useCallback, useState } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { UserDetails } from 'types/user'
import { DEFAULT_TOKEN_DECIMALS } from 'utils/bigNumber'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { isMobile } from 'utils/userAgent'

import { ConfirmModal } from './ConfirmModal'

const MyDataInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 16px;
  margin-top: 2rem;
`

const StyleDivInput = styled.div`
  display: flex;
  border: 1px solid #8247e5;
  border-radius: 24px;
  flex-direction: row;
  width: 100%;
  padding: 8px;
  justify-content: space-between;
  margin-top: 1rem;
`
const StyledInput = styled(NumericalInput)`
  background-color: transparent;
  text-align: center;
  width: 100%;
  padding: 0 10px;
  font-size: 18px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 16px;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    font-size: 12px;
  `};
`

interface Props {
  playerData: UserDetails
}

const SellChips: React.FC<Props> = ({ playerData }) => {
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [hash, setHash] = useState<string | undefined>()
  const [attempting, setAttempting] = useState(false)
  const showConnectAWallet = Boolean(!account)
  const [localValue, setLocalValue] = useState('')

  const { swcBalance, chipsBalance } = playerData

  const bigValue = new BigNumber(localValue ? localValue : '0').times(DEFAULT_TOKEN_DECIMALS)
  const hasFunds = chipsBalance.gte(bigValue)

  const bankContract = useBankContract()

  const handleSell = async () => {
    try {
      setAttempting(true)
      const value = bigValue.toFixed(0)
      const response = await bankContract?.sellCredits(value)?.catch(() => {
        setAttempting(false)
      })
      await response?.wait()

      if (response?.hash) setHash(response?.hash)
      playerData.fetchData()
    } catch (error) {
      setAttempting(false)
    }
  }

  const handleDismissSubmissionModal = useCallback(() => {
    setHash(undefined)
    setAttempting(false)
  }, [setHash, setAttempting])

  return (
    <>
      <MyDataInfo>
        <ThemedText.Body fontSize={isMobile ? '12px' : '18px'}>
          <Trans>My CHIPS</Trans>: {getFullDisplayBalance(chipsBalance, 18, 2)}
        </ThemedText.Body>
        <ThemedText.Body fontSize={isMobile ? '12px' : '18px'}>
          <Trans>My SWC</Trans>: {getFullDisplayBalance(swcBalance, 18, 2)}
        </ThemedText.Body>
      </MyDataInfo>
      <div style={{ width: '80%', marginLeft: '10%' }}>
        <StyleDivInput>
          <StyledInput
            className="amount"
            type="number"
            step={0.0}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            placeholder={t`Enter Amount`}
            value={localValue}
            onUserInput={(val) => {
              setLocalValue(val)
            }}
          />
          <ButtonGray
            width={isMobile ? '20%' : '10%'}
            height={isMobile ? '10px' : '10px'}
            disabled={showConnectAWallet}
            onClick={() => {
              setLocalValue(chipsBalance ? getFullDisplayBalance(chipsBalance, 18, 18) : '0')
            }}
          >
            Max
          </ButtonGray>
        </StyleDivInput>
      </div>
      <div style={{ width: '80%', marginLeft: '10%' }}>
        {!showConnectAWallet && (
          <ButtonPrimary
            justifyContent="center"
            style={{ marginTop: '1rem', padding: '8px 16px' }}
            disabled={bigValue.lte(0) || !hasFunds || attempting}
            onClick={handleSell}
          >
            {!hasFunds ? <Trans>Insufficient funds</Trans> : <Trans>Sell</Trans>}
          </ButtonPrimary>
        )}

        {showConnectAWallet && (
          <ButtonPrimary style={{ marginTop: '1rem', padding: '8px 16px' }} onClick={toggleWalletModal}>
            <Trans>Connect a wallet</Trans>
          </ButtonPrimary>
        )}
        <ConfirmModal isOpen={attempting} hash={hash} onDismiss={handleDismissSubmissionModal} />
      </div>
    </>
  )
}

export default SellChips
